// vim: set ts=2 sts=2 sw=2 et:

import { PlatformRef } from "../types";
import {
  bridgeUrlToWebSocketUrl,
  buildPlatformLiveUrls,
  buildPlatformLiveUrlsForRemoteBridge,
} from "./platformLiveLauncher";
import { PlatformLiveProfile } from "./platformLiveProfile";
import { getPlatformLiveBridgeConfig, isRemotePlatformLiveBridge } from "./platformLiveBridgeClient";
import { PLATFORM_LIVE_WS_PATH, getPlatformLiveWebSocketUrl } from "./platformLiveProtocol";

export const canUseBrowserWebSocket = (): boolean => {
  return typeof window !== "undefined" && typeof window.WebSocket === "function";
};

export const buildLiftingLocationSearch = (profile: PlatformLiveProfile, appOrigin: string): string => {
  const wsUrl = resolvePlatformLiveWebSocketUrl(
    { day: profile.day, platformId: profile.platformId },
    "",
    appOrigin,
    profile,
  );
  return `?lifting&ws=${encodeURIComponent(wsUrl)}`;
};

export const resolvePlatformLiveWebSocketUrl = (
  platformRef: PlatformRef,
  search: string,
  appOrigin: string,
  activeProfile: PlatformLiveProfile | null,
): string => {
  const override = new URLSearchParams(search).get("ws");
  if (override !== null && override.length > 0) {
    return override;
  }

  if (activeProfile !== null) {
    const bridgeConfig = getPlatformLiveBridgeConfig(activeProfile.bridgeProviderId);
    if (bridgeConfig !== null && isRemotePlatformLiveBridge(bridgeConfig)) {
      return buildPlatformLiveUrlsForRemoteBridge(activeProfile, bridgeConfig.url, appOrigin).wsUrl;
    }
    return buildPlatformLiveUrls(activeProfile).wsUrl;
  }

  const bridgeConfig = getPlatformLiveBridgeConfig();
  if (bridgeConfig !== null && isRemotePlatformLiveBridge(bridgeConfig)) {
    return bridgeUrlToWebSocketUrl(bridgeConfig.url);
  }

  if (typeof window === "undefined") {
    const port = 4510 + platformRef.platformId;
    return `ws://127.0.0.1:${port}${PLATFORM_LIVE_WS_PATH}`;
  }

  return getPlatformLiveWebSocketUrl(platformRef, window.location, search);
};

export const getBrowserPlatformLiveWebSocketUrl = (
  platformRef: PlatformRef,
  search: string,
  activeProfile: PlatformLiveProfile | null = null,
): string => {
  const appOrigin = typeof window !== "undefined" ? window.location.origin : "http://127.0.0.1:5000";
  return resolvePlatformLiveWebSocketUrl(platformRef, search, appOrigin, activeProfile);
};
